import { CourierBalanceFilter, TotalBalanceFilterDto } from '@core/interfaces/courier-balance.interface';
import { NgbDateRange } from '@core/interfaces/date-filter.interface';
import { GetListParams, SortInterface } from '@core/interfaces/get-list.interface';
import { OffsetPagination } from '@core/interfaces/pagination-params.interface';
import { CourierBalancesTypeEnum } from '@core/enums/courier-balances.enum';

export class GetListEncashmentTransactions {
  static readonly type = '[GetListEncashmentTransactions] Get List Encashment Transactions';

  constructor(public params?: GetListParams<CourierBalanceFilter>) {}
}

export class GetListCourierBalance {
  static readonly type = '[GetListCourierBalance] Get List Courier Balance';

  constructor(public params?: GetListParams<CourierBalanceFilter>) {}
}

export class SetTransactionsFilter {
  static readonly type = '[SetTransactionsFilter] Set Transactions Filter';

  constructor(public filter: CourierBalanceFilter) {}
}

export class SetTransactionsPagination {
  static readonly type = '[SetTransactionsPagination] Set Transactions Pagination';

  constructor(public paginationParams: OffsetPagination) {}
}

export class SetCourierBalanceDateFilter {
  static readonly type = '[SetBalancesDateFilter] Set Balances Date Filter';

  constructor(public dateFilter: NgbDateRange) {}
}

export class SetCourierBalanceActiveTab {
  static readonly type = '[SetCourierBalanceActiveTab] Set Courier Balance Active Tab';

  constructor(public tab: CourierBalancesTypeEnum) {}
}

export class GetCouriersTotalBalance {
  static readonly type = '[CourierBalance] Load Total Balance';

  constructor(public filter?: TotalBalanceFilterDto) {}
}

export class SetEncashmentTransactionsSort {
  static readonly type = '[SetEncashmentTransactionsSort] Set Encashment Transactions Sort';

  constructor(public sort: SortInterface) {}
}

export class SetCourierBalanceSort {
  static readonly type = '[SetCourierBalanceSort] Set Courier Balance Sort';

  constructor(public sort: SortInterface) {}
}
